import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  detailAttendanceApi,
  getAttendanceRequestApi,
  getReportAttendance,
  updateAttendanceApi,
  updateAttendanceRequestAllApi,
  updateAttendanceRequestApi,
} from "./attendanceApi";

interface IParamsGetReport {
  stardate: string | Date;
  enddate: string | Date;
}

export const getReportAttendanceRequest = createAsyncThunk(
  "getReportAttendance/attendance",
  async (payload: IParamsGetReport) => {
    try {
      const response = await getReportAttendance(payload);
      return response;
    } catch (error) {}
  }
);

export const detailAttendanceRequest = createAsyncThunk(
  "detailAttendanceRequest/attendance",
  async (payload: any) => {
    try {
      const response = await detailAttendanceApi(payload);
      return response;
    } catch (error) {}
  }
);

export const updateAttendanceRequest = createAsyncThunk(
  "updateAttendanceRequest/attendance",
  async (payload: any) => {
    try {
      const response = await updateAttendanceApi(payload);
      return response;
    } catch (error) {}
  }
);

export const getAttendanceRequest = createAsyncThunk(
  "getAttendanceRequest/attendance",
  async (payload: any) => {
    try {
      const response = await getAttendanceRequestApi(payload);
      return response;
    } catch (error) {}
  }
);

export const updateApprovalAttendanceRequest = createAsyncThunk(
  "updateApprovalAttendanceRequest/attendance",
  async (payload: any) => {
    try {
      const response = await updateAttendanceRequestApi(payload);
      return response;
    } catch (error) {}
  }
);

export const updateApprovalAttendanceAllRequest = createAsyncThunk(
  "updateApprovalAttendanceAllRequest/attendance",
  async () => {
    try {
      const response = await updateAttendanceRequestAllApi();
      return response;
    } catch (error) {}
  }
);

interface IInitialState {
  pageIsLoading: boolean;
  reportList: any[];
  reportListRequest: any[];
  attendanceMessage: string;
  detail: any;
  update: any;
  updateRequest: any;
  approveAll: any;
}

const initialState: IInitialState = {
  pageIsLoading: false,
  reportList: [],
  reportListRequest: [],
  attendanceMessage: "",
  detail: null,
  update: null,
  updateRequest: null,
  approveAll: null,
};

const attendanceSlice = createSlice({
  name: "attendance",
  initialState: initialState,
  reducers: {
    resetAttendanceMessage: (state) => {
      state.attendanceMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReportAttendanceRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getReportAttendanceRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.attendanceMessage = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.reportList = action.payload.data;
        state.attendanceMessage = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getReportAttendanceRequest.rejected, (state) => {
      state.attendanceMessage = "get report attendance is FAIL";
      state.pageIsLoading = false;
    });

    // detail
    builder.addCase(detailAttendanceRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(detailAttendanceRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.attendanceMessage = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.detail = action.payload.data;
        state.attendanceMessage = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(detailAttendanceRequest.rejected, (state) => {
      state.attendanceMessage = "get report attendance is FAIL";
      state.pageIsLoading = false;
    });

    // update
    builder.addCase(updateAttendanceRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateAttendanceRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.attendanceMessage = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.update = action.payload.data;
        state.attendanceMessage = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateAttendanceRequest.rejected, (state) => {
      state.attendanceMessage = "update attendance is FAIL";
      state.pageIsLoading = false;
    });

    // request
    builder.addCase(getAttendanceRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getAttendanceRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.attendanceMessage = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.reportListRequest = action.payload.data;
        state.attendanceMessage = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getAttendanceRequest.rejected, (state) => {
      state.attendanceMessage = "update attendance is FAIL";
      state.pageIsLoading = false;
    });

    // update request
    builder.addCase(updateApprovalAttendanceRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(
      updateApprovalAttendanceRequest.fulfilled,
      (state, action) => {
        if (action.payload.status !== 1000) {
          state.attendanceMessage = action.payload.message;
          state.pageIsLoading = false;
        } else {
          state.updateRequest = action.payload.data;
          state.attendanceMessage = action.payload.message;
          state.pageIsLoading = false;
        }
      }
    );
    builder.addCase(updateApprovalAttendanceRequest.rejected, (state) => {
      state.attendanceMessage = "update attendance is FAIL";
      state.pageIsLoading = false;
    });

    // update all request
    builder.addCase(updateApprovalAttendanceAllRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(
      updateApprovalAttendanceAllRequest.fulfilled,
      (state, action) => {
        if (action.payload.status !== 1000) {
          state.attendanceMessage = action.payload.message;
          state.pageIsLoading = false;
        } else {
          state.approveAll = action.payload.data;
          state.attendanceMessage = action.payload.message;
          state.pageIsLoading = false;
        }
      }
    );
    builder.addCase(updateApprovalAttendanceAllRequest.rejected, (state) => {
      state.attendanceMessage = "update attendance is FAIL";
      state.pageIsLoading = false;
    });
  },
});

export const { resetAttendanceMessage } = attendanceSlice.actions;
export default attendanceSlice.reducer;
